<script>
export default {
  mounted() {
    this.injectTelegramScript();
  },
  methods: {
    injectTelegramScript() {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://telegram.org/js/telegram-widget.js?22';
      script.setAttribute('data-telegram-login', window.chatwootConfig.telegramBotName);
      script.setAttribute('data-size', 'large');
      // Using redirect mode for easier integration with OmniAuth
      script.setAttribute('data-auth-url', `${window.chatwootConfig.hostURL}/auth/telegram/callback`);
      script.setAttribute('data-request-access', 'write');
      this.$refs.telegramButton.appendChild(script);
    },
  },
};
</script>

<template>
  <div ref="telegramButton" class="flex justify-center w-full" />
</template>
